module.exports = __webpack_public_path__ + "img/top_slider_ecoproject06.38df8913.jpg";